<template>
  <section class="home-new-section key-fund">
    <div class="container">
      <div class="layout">
        <div class="section-inner ">

            <new-scheme-information :asComponent="true" />

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import NewSchemeInformation from './newSchemeInformation.vue';


export default {
    name: 'key-information',

    components: {
        NewSchemeInformation,
    },


};
</script>

<style lang="scss" scoped>
.key-fund {
  position: relative;
      margin-bottom: 50px;


}
</style>
